import api from '../..'

type Id = string | number

export type RestartParticipantsOptions = {
  sendReport?: boolean
}

const restartParticipants = (
  course: Id,
  options?: RestartParticipantsOptions
) => {
  return api.delete(`administration/courses/${course}/participants`, {
    data: { options },
  })
}
export default restartParticipants
